module.exports = __webpack_public_path__ + "img/pic_15.ea74f85c.jpg";